module.exports = __webpack_public_path__ + "93625642d9c8274a7f9d72b15b8d4c37.png";